import React, { useEffect } from 'react'
import { useState } from 'react'

import { useAxios } from '../../utilities/Requests/useAxios'

export type FeatureFlag = {
  featureName: string
  enabled: boolean
}

export interface FeatureFlagContextInterface {
  featureFlags: FeatureFlag[]
  getFeatureFlags: () => Promise<FeatureFlag[]>
}

export const FeatureFlagContext =
  React.createContext<FeatureFlagContextInterface | null>(null)

export const FeatureFlagProvider = ({ children }: any) => {
  const { fetch } = useAxios()

  const [featureFlags, setFeatureFlags] = useState<FeatureFlag[]>([])

  const getFeatureFlags = async () => {
    const { data, error } = await fetch({
      path: `VersionCheck/GetFeatureFlags`,
    })
    if (data) {
      setFeatureFlags(data)
      return data
    } else if (error) {
      throw new Error(`Error in getting FeatureFlag records.`)
    }
  }

  useEffect(() => {
    getFeatureFlags()
  }, [])

  return (
    <FeatureFlagContext.Provider
      value={{
        getFeatureFlags,
        featureFlags,
      }}
    >
      {children}
    </FeatureFlagContext.Provider>
  )
}
